export default "__VITE_ASSET__DVGzqRb$__"